import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { registerAppIcons } from './icons.config';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor() {
    registerAppIcons();
  }
}
